"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _EventTypes = _interopRequireDefault(require("../../enum/EventTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * fetch duration
 * @param {*} scout
 */
function init(scout) {
  var perfResIndex = 0;
  var NativeFetch = fetch;
  var keyOb = {};

  window.fetch = function newFetch() {
    return NativeFetch.apply(void 0, arguments)["finally"](function () {
      setTimeout(function () {
        try {
          var list = _toConsumableArray(performance.getEntriesByType("resource"));

          var newList = list.filter(function (item) {
            return item.initiatorType === "fetch";
          });
          newList.forEach(function (timing) {
            var key = timing.name + "_" + timing.fetchStart + "_" + timing.duration;

            if (keyOb[key]) {
              return;
            } else {
              var url = timing.name || "";
              var urlNoSearch = timing.name.split("?")[0] || "";
              var pathname = "/".concat(urlNoSearch.split("//")[1].split("/").slice(1).join("/"));
              scout.track(_EventTypes["default"].FETCH_DURATION, {
                url: url,
                url_no_search: urlNoSearch,
                pathname: pathname,
                duration: timing.duration
              });
              keyOb[key] = true;
            }
          });
          perfResIndex = list.length;
        } catch (e) {
          console.log(e);
        }
      }, 0);
    });
  };
}

var _default = {
  init: init,
  name: "FetchDuraiton"
};
exports["default"] = _default;